import { useCallback, useEffect, useRef, useState } from "react";
export default function Iframe({ url, messagehandllers, title }) {
  const ref = useRef();
  const [heigth, setHeigth] = useState(null);

  const hanldeMessage = useCallback(
    (event) => {
      // Built-in resize handler: the embedded page can send
      // { command: "resize", height: <number> } via postMessage
      if (event.data && event.data.command === "resize" && event.data.height) {
        setHeigth(event.data.height + "px");
      }

      if (
        messagehandllers &&
        messagehandllers.origin === event.origin &&
        messagehandllers[event.data.command]
      ) {
        messagehandllers[event.data.command](event);
      }
    },
    [messagehandllers]
  );

  // For same-origin iframes, read content height directly on load
  const handleLoad = useCallback(() => {
    try {
      const doc = ref.current?.contentWindow?.document;
      if (doc) {
        const contentHeight = doc.documentElement.scrollHeight;
        setHeigth(contentHeight + "px");
      }
    } catch {
      // Cross-origin: cannot access document, rely on postMessage instead
    }
  }, []);

  useEffect(() => {
    window.addEventListener("message", hanldeMessage);

    return () => window.removeEventListener("message", hanldeMessage);
  }, [hanldeMessage]);

  return (
    <iframe
      ref={ref}
      src={url}
      title={title}
      style={{
        width: "100%",
        height: heigth || "calc(100vh - 120px)",
        border: "none",
        minHeight: "600px"
      }}
      onLoad={handleLoad}
    />
  );
}
